export default function selectYourStashController() {
  const container = document.querySelector('.select-your-stash');

  if (!container) {
    removeSelectYourStashCartAttribute();
    return;
  }

  let rechargeHeadingContainer = null;
  let rechargeFrequencyElement = null;
  let nextStepButton = null;

  const categoriesSwiper = container.querySelector('.select-your-stash__categories');

  const cart = container.querySelector('.select-your-stash__cart');
  const cartTotalSelectedCount = cart.querySelector('.select-your-stash__cart__selected');
  const cartTotals = container.querySelector('.select-your-stash__cart__totals');
  const cartSubtotal = cartTotals.querySelector('.subtotal .select-your-stash__cart__totals__item__value');
  const cartSavings = cartTotals.querySelector('.savings .select-your-stash__cart__totals__item__value');
  const cartItemsElement = cart.querySelector('.select-your-stash__cart__items');

  const cartToggleButton = container.querySelector('.select-your-stash__cart__toggle');

  const checkoutButton = cart.querySelector('.select-your-stash__cart__checkout');
  const checkoutButtonTotal = cart.querySelector('.select-your-stash__cart__checkout__total');
  const checkoutButtonSubtotal = cart.querySelector('.select-your-stash__cart__checkout__subtotal');

  const searchInput = container.querySelector('input[name="select-your-stash-search"]');

  const productsEmpty = container.querySelector('.select-your-stash__products-empty');

  const rewardTracker = container.querySelector('.select-your-stash__cart__tiered-reward-tracker');
  const rewardTrackerLine = rewardTracker.querySelector('.select-your-stash__cart__tiered-reward-tracker__line');
  const rewardTrackerRewards = rewardTracker.querySelector('.select-your-stash__cart__tiered-reward-tracker__rewards');

  const products = new Map();
  const categories = new Map();

  const rewards = getRewardsData();

  let currentCategoryId = null;
  let purchaseType = 'subscription'; // one-time

  init();

  function changeCategory(categoryId) {
    const category = categories.get(categoryId);
    if (category.element.classList.contains('active')) {
      return;
    }

    categories.forEach((categoryData, id) => {
      if (id === categoryId) {
        categoryData.element.classList.add('active');
      } else {
        categoryData.element.classList.remove('active');
      }
    });

    currentCategoryId = categoryId;

    filterProducts();
  }

  function filterProducts() {
    const searchValue = searchInput.value.trim().toLowerCase();

    let isHiddenCount = 0;

    products.forEach((productsData) => {
      const productTitle = productsData.title.toLowerCase();

      let isHidden = productsData.categoryIds.includes(currentCategoryId) === false;

      if (searchValue.length && !productTitle.includes(searchValue)) {
        isHidden = true;
      }

      isHiddenCount += +isHidden;

      productsData.element.classList.toggle('hidden', isHidden);
    });

    productsEmpty.classList.toggle('hidden', isHiddenCount !== products.size);
  }

  function getEmptyCartItemHtml() {
    return `<div class="swiper-slide select-your-stash__cart__item"><div class="select-your-stash__cart__item__add"></div></div>`;
  }

  function createCartItem(productId) {
    const cartItem = cartItemsElement.querySelector('[data-product-id="' + productId + '"]');
    if (cartItem) {
      updateCartItem(productId, 1);
      return;
    }

    const productData = products.get(productId);
    if (!productData) {
      console.warn(`Product with ID ${productId} not found.`);
      return;
    }

    const finalPriceText = formatMoney(getProductPrice(productId).final);
    const imageSrc = productData.imageSrc;

    const img = imageSrc ? `<img src="${imageSrc}" alt="${productData.title} image" width="47" height="47">` : '';

    const html = `
    <div class="swiper-slide select-your-stash__cart__item" data-product-id="${productId}">
      <button class="select-your-stash__cart__item__remove"></button>
      ${img}
      <span class="select-your-stash__cart__item__content">
        <span class="select-your-stash__cart__item__title">1 Pack</span>
        <span class="select-your-stash__cart__item__price">${finalPriceText}</span>
      </span>
    </div>`;

    cartItemsElement.insertAdjacentHTML('afterbegin', html);
    cartItemsElement.parentElement?.swiper?.update();
  }

  function updateCartItem(productId, quantity) {
    const cartItem = cartItemsElement.querySelector('[data-product-id="' + productId + '"]');
    if (!cartItem) {
      console.warn(`Cart item for product with ID ${productId} not found.`);
      return;
    }

    const finalPriceText = formatMoney(getProductPrice(productId).final * quantity);

    const titleText = `${quantity} Pack${quantity > 1 ? 's' : ''}`;

    const cartItemTitle = cartItem.querySelector('.select-your-stash__cart__item__title');
    const cartItemPrice = cartItem.querySelector('.select-your-stash__cart__item__price');

    if (cartItemTitle) {
      cartItemTitle.textContent = titleText;
    }
    if (cartItemPrice) {
      cartItemPrice.textContent = finalPriceText;
    }
  }

  function setItemQuantity(productId, quantity) {
    const productData = products.get(productId);
    if (!productData) {
      console.warn(`Product with ID ${productId} not found.`);
      return;
    }

    const rbItem = productData.rbItem;

    if (!rbItem) {
      console.warn(`RB Item for product with ID ${productId} not found.`);
      return;
    }

    const rbInput = productData.rbInput;
    if (!rbInput) {
      console.warn(`RB Input for product with ID ${productId} not found.`);
      return;
    }

    rbInput.value = quantity;
    rbInput.dispatchEvent(new Event('change', { bubbles: true }));

    const cardQuickAdd = productData.element.querySelector('.quick-add__bundle');

    if (cardQuickAdd) {
      cardQuickAdd.classList.toggle('show-quantity-input', quantity >= 1);
    }

    if (quantity == 1) {
      createCartItem(productId);
    } else if (quantity > 1) {
      updateCartItem(productId, quantity);
    } else if (quantity <= 0) {
      removeCartItem(productId, false);
    }

    updateTotalSelectedCount();
  }

  function removeCartItem(productId, updateNext = true) {
    const cartItem = cartItemsElement.querySelector('[data-product-id="' + productId + '"]');
    if (!cartItem) {
      console.warn(`Cart item for product with ID ${productId} not found.`);
      return;
    }

    const productData = products.get(productId);
    if (!productData) {
      console.warn(`Product with ID ${productId} not found.`);
      return;
    }

    cartItem.remove();

    if (!updateNext) {
      return;
    }

    if (productData?.quantityInput?.input) {
      productData.quantityInput.input.value = 1;
    }

    setItemQuantity(productId, 0);
    cartItemsElement.parentElement?.swiper?.update();
  }

  function updateTotalSelectedCount() {
    let totalSelectedCount = 0;

    products.forEach((productData) => {
      const rbInput = productData.rbInput;
      if (rbInput && rbInput.value) {
        totalSelectedCount += parseInt(rbInput.value, 10) || 0;
      }
    });

    cartTotalSelectedCount.textContent = `(${totalSelectedCount} selected)`;
    cartTotalSelectedCount.classList.toggle('hidden', totalSelectedCount === 0);
  }

  function init() {
    prepareProducts();
    prepareFilters();

    prepareCart();
    prepareRewardTracker();

    showHideCartController();

    //work with products
    waitForElement(
      (parent, target) => {
        const rbApp = target.closest('.rb-app');

        if (!rbApp) {
          return;
        }

        const rbProducts = rbApp.querySelectorAll('.rb-items-wrapper .rb-item');

        if (rbProducts && rbProducts.length) {
          rbProducts.forEach((rbProduct) => {
            const productId = rbProduct.dataset.rbItemId;
            const rbInput = rbProduct.querySelector('.rb-item-actions .rb-input');

            const productData = products.get(productId);

            if (productData) {
              products.set(productId, {
                ...productData,
                isRbItem: true,
                rbItem: rbProduct,
                rbInput: rbInput,
              });
            }
          });
        }

        products.forEach((productData, productId) => {
          if (!productData.isRbItem) {
            productData.element.remove();
            products.delete(productId);
          }

          const quantityInput = productData.element.querySelector('.quick-add__bundle .quantity');

          if (quantityInput?.input) {
            quantityInput.input.addEventListener('change', (event) => {
              const qty = parseInt(event.target.value, 10);
              if (isNaN(qty) || qty < 0) {
                console.warn(`Invalid quantity for product with ID ${productId}: ${qty}`);
                return;
              }

              setItemQuantity(productId, qty);
            });
          }

          const quickAddBundle = productData.element.querySelector('.quick-add__bundle > .button');

          if (quickAddBundle) {
            quickAddBundle.addEventListener('click', (event) => {
              if (quantityInput.input) {
                quantityInput.input.value = 1;
                quantityInput.input.dispatchEvent(new Event('change', { bubbles: true }));
              }
              // setItemQuantity(productId, 1);
            });
          }
        });

        const rbCategories = rbApp.querySelectorAll('.rb-container .rb-section');
        let firstCategoryId = null;
        if (rbCategories && rbCategories.length) {
          rbCategories.forEach((rbCategory) => {
            const categoryId = rbCategory.id;
            const categoryData = categories.get(categoryId);

            if (categoryData) {
              categories.set(categoryId, {
                ...categoryData,
                isRbCategory: true,
              });

              if (!firstCategoryId) {
                firstCategoryId = categoryId;
              }
            }
          });
        }

        categories.forEach((categoryData, categoryId) => {
          if (!categoryData.isRbCategory) {
            categoryData.element.remove();
            categories.delete(categoryId);
          }

          categoryData.element.addEventListener('click', () => {
            changeCategory(categoryId);
          });

          categoryData.element.classList.remove('hidden');
        });

        if (firstCategoryId) {
          changeCategory(firstCategoryId);
        }

        categoriesSwiper.init();

        nextStepButton = rbApp.querySelector('.rb-form .rb-btn');
        startNextStepButtonSync();

        // const rechargeForm = rbApp.querySelector('form.rb-form');
        rechargeFrequencyElement = rbApp.querySelector('.rb-form #selling-plan-list');
        startDeliveryFrequencySync();

        rechargeHeadingContainer = rbApp.querySelector('.rb-header .rb-container.rb-heading');
        startPriceSync();

        container.classList.remove('is-loading');
      },
      '#MainContent',
      '#recharge-bundles .rb-form',
      100
    );
  }

  function showHideCartController() {
    cartToggleButton.addEventListener('click', function () {
      cart.classList.toggle('opened');
    });
    // whenInViewport(
    //   container,
    //   (entry) => {
    //     container.classList.toggle('is-in-viewport', entry.isIntersecting);
    //   },
    //   {
    //     once: false,
    //     onlyWhenIntersecting: false,
    //     threshold: null,
    //   }
    // );
  }

  function startNextStepButtonSync() {
    checkoutButton.addEventListener('click', function () {
      if (nextStepButton && !nextStepButton.disabled) {
        manipulateRealCart().then(() => {
          nextStepButton.click();
        });
      }
    });

    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type !== 'attributes') {
          return;
        }

        checkoutButton.disabled = nextStepButton.disabled;
      });
    });

    if (nextStepButton) {
      checkoutButton.disabled = nextStepButton.disabled;

      observer.observe(nextStepButton, {
        attributes: true,
        attributeFilter: ['disabled'],
      });
    }
  }

  function removeSelectYourStashCartAttribute() {
    removeCartAttributes('select-your-stash')
      .then(() => {
        console.log('Cart attribute "select-your-stash" removed successfully.');
      })
      .catch((error) => {
        console.error('Error removing cart attribute "select-your-stash":', error);
      });
  }

  function manipulateRealCart() {
    return new Promise((resolve, reject) => {
      fetch('/cart/clear.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(() => {
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              attributes: {
                'select-your-stash': purchaseType,
              },
            }),
          });
        })
        .then((res) => res.json())
        .then((cart) => {
          console.log('Cart cleared and attribute set:', cart);
          resolve(cart);
        })
        .catch((error) => {
          console.error('Error during cart reset and update:', error);
          reject(error);
        });
    });
  }

  function startDeliveryFrequencySync() {
    if (!rechargeFrequencyElement) {
      return;
    }

    const frequencySelectClone = rechargeFrequencyElement.cloneNode(true);
    frequencySelectClone.selectedIndex = rechargeFrequencyElement.selectedIndex;

    cart.querySelector('.select-your-stash__cart__delivery').appendChild(frequencySelectClone);

    frequencySelectClone.addEventListener('change', function () {
      rechargeFrequencyElement.selectedIndex = this.selectedIndex;
      rechargeFrequencyElement.dispatchEvent(new Event('change'));

      const sellingPlanId = this?.options[this?.selectedIndex]?.dataset?.sellingPlanId;

      purchaseType = sellingPlanId == '0' ? 'one-time' : 'subscription';

      console.log(purchaseType);

      setTimeout(() => {
        updateProductPrices();
        // modifyRechargeItems();
        // syncCartAndRechargeProducts();
      }, 25);
    });

    updateProductPrices();
  }

  function startPriceSync() {
    if (!rechargeHeadingContainer) {
      return;
    }

    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type !== 'childList') {
          return;
        }

        const priceContainer = rechargeHeadingContainer.querySelector('.rb-price');

        if (!priceContainer) {
          cartSavings.textContent = '';
          cartSubtotal.textContent = '';
          checkoutButtonTotal.textContent = '';
          checkoutButtonSubtotal.textContent = '';
          updateRewardTracker(0);
          return;
        }

        const priceText = priceContainer.textContent;

        const prices = parsePriceText(priceText);

        const subtotal = prices.regular;
        const rewardDiscounts = updateRewardTracker(prices.final || prices.regular);
        const savings = prices.final ? prices.regular - prices.final : 0;
        const final = subtotal - savings;

        cartSavings.textContent = intlFormatMoney(savings, prices.currency);
        cartSubtotal.textContent = intlFormatMoney(subtotal, prices.currency);
        checkoutButtonTotal.textContent = intlFormatMoney(final, prices.currency);
        checkoutButtonSubtotal.textContent = savings > 0 ? intlFormatMoney(subtotal, prices.currency) : '';
      });
    });

    observer.observe(rechargeHeadingContainer, {
      childList: true,
      subtree: true,
    });
  }

  function updateRewardTracker(currentPrice) {
    if (!rewards?.length) {
      return 0;
    }

    rewardTrackerRewards.querySelector('.starting-reward')?.classList?.toggle('active', currentPrice > 0);

    let discount = 0;
    let latestActiveRewardIndex = -1;

    rewards.forEach((reward, index) => {
      const rewardElement = rewardTrackerRewards.querySelector(`[data-reward-index="${index}"]`);
      const isActiveReward = currentPrice >= reward.cartSize;
      rewardElement.classList.toggle('active', isActiveReward);

      if (isActiveReward) {
        latestActiveRewardIndex = index;
        discount += reward.discount || 0;
      }
    });

    rewardTrackerRewards.style.setProperty('--current-reward-index', latestActiveRewardIndex);

    const currentProgress = getRewardProgress(currentPrice);
    rewardTrackerLine.style.setProperty('--progress', currentProgress);

    return discount;
  }

  function getRewardProgress(currentPrice) {
    const segments = rewards.length; // 4 rewards → 4 equal 25 % slices

    // ▸ 0 … first reward
    if (currentPrice <= rewards[0].cartSize) {
      return currentPrice / rewards[0].cartSize / segments;
    }

    // ▸ Between two rewards
    for (let i = 1; i < segments; i++) {
      const prev = rewards[i - 1].cartSize;
      const next = rewards[i].cartSize;

      if (currentPrice <= next) {
        const rangeProgress = (currentPrice - prev) / (next - prev); // 0 → 1 inside slice
        return i / segments + rangeProgress / segments; // base + slice part
      }
    }

    // ▸ Above the last reward
    return 1;
  }

  function updateProductPrices() {
    products.forEach((productData) => {
      const rbPrice = productData.rbItem?.querySelector('.rb-price');
      if (!rbPrice) {
        return;
      }

      const productPrice = productData.element.querySelector('.card-information .price');
      if (!productPrice) {
        return;
      }

      const ariaLabel = rbPrice.getAttribute('aria-label');
      productPrice.setAttribute('aria-label', ariaLabel || 'Product Price');
      productPrice.innerHTML = rbPrice.innerHTML;

      const qty = parseInt(productData.rbInput?.value, 10) || 0;
      if (qty > 0) {
        updateCartItem(productData.id, parseInt(productData.rbInput?.value, 10) || 1);
      }
    });
  }

  function parsePriceText(text) {
    const matches = text.match(/(?:[$€£]?\d{1,3}(?:,\d{3})*(?:\.\d{2})?(?:\s?(?:USD|EUR|GBP))?)/g);
    if (!matches) return null;

    let prices = matches
      .map((match) => {
        const value = parseFloat(match.replace(/[$€£,]/g, ''));
        let currency = match.includes('$') ? 'USD' : match.includes('€') ? 'EUR' : match.includes('£') ? 'GBP' : null;

        if (!currency) {
          if (/USD/.test(text)) currency = 'USD';
          else if (/EUR/.test(text)) currency = 'EUR';
          else if (/GBP/.test(text)) currency = 'GBP';
        }

        return { currency, value };
      })
      .filter((item) => !isNaN(item.value));

    if (prices.length === 0) return null;

    prices.sort((a, b) => b.value - a.value);

    return {
      regular: prices[0].value,
      final: prices.length > 1 ? prices[1].value : null,
      currency: prices[0].currency || 'Unknown',
    };
  }

  function getProductPrice(productId) {
    const productData = products.get(productId);
    if (!productData) {
      console.warn(`Product with ID ${productId} not found.`);
      return null;
    }

    const rbPrice = productData.rbItem?.querySelector('.rb-price');
    const regularPriceElement = rbPrice?.querySelector('.rb-full-price');

    const regularPriceText = regularPriceElement ? getOwnTextContent(regularPriceElement) : '';
    const finalPriceText = rbPrice ? getOwnTextContent(rbPrice) : '';

    const regularPrice = extractNumberPriceFromText(regularPriceText);
    const finalPrice = extractNumberPriceFromText(finalPriceText);

    return {
      regular: regularPrice,
      final: finalPrice || regularPrice,
      currency: 'USD',
    };
  }

  function prepareProducts() {
    const productElements = document.querySelectorAll('.js-select-your-stash-products .card-wrapper');

    if (productElements && productElements.length) {
      productElements.forEach((productCardWrapper) => {
        const productCard = productCardWrapper.querySelector('.card');
        const productId = productCard.dataset.productId;
        const productCategoryIds = JSON.parse(
          productCardWrapper.querySelector('[data-product-category-ids]')?.textContent || '[]'
        );
        const productHeading = productCard.querySelector('.card__heading');
        const productTitle = productHeading?.textContent?.trim() || '';
        const productImageSrc = productCard.querySelector('.card__media img')?.src || null;

        const quantityInput = productCardWrapper.querySelector('.quantity');

        //TODO: set max quantity based on product availability
        if (quantityInput?.input) {
          quantityInput.input.min = 0;
          quantityInput.input.max = 20;
        }
        // if (productHeading) {
        //   const productLink = productHeading.querySelector('a');
        //   if (productLink) {
        //     productLink.target = '_blank';
        //     productLink.rel = 'noopener noreferrer';
        //   }
        // }

        products.set(productId, {
          id: productId,
          categoryIds: productCategoryIds,
          element: productCardWrapper,
          title: productTitle,
          imageSrc: productImageSrc,
          quantityInput: quantityInput,
        });
      });
    }
  }

  function prepareFilters() {
    const categoryElements = document.querySelectorAll('.js-select-your-stash-category');

    if (categoryElements && categoryElements.length) {
      categoryElements.forEach((categoryElement) => {
        const categoryId = categoryElement.dataset.collectionId;

        categories.set(categoryId, {
          id: categoryId,
          element: categoryElement,
        });
      });
    }

    searchInput.addEventListener(
      'input',
      debounce((event) => {
        filterProducts();
      }, 200)
    );
  }

  function prepareRewardTracker() {
    if (!rewards?.length) {
      rewardTracker.classList.add('hidden');
      return;
    }

    const rewardsHtml = rewards.reduce((html, reward, index) => {
      return (
        html +
        `
        <div class="select-your-stash__cart__tiered-reward-tracker__reward" data-reward-index="${index}" data-cart-size="${reward.cartSize}">
          <div class="select-your-stash__cart__tiered-reward-tracker__reward__title">${reward.title}<div class="select-your-stash__cart__tiered-reward-tracker__reward__confetti"></div></div>
          <div class="select-your-stash__cart__tiered-reward-tracker__reward__milestone">${reward.milestone}</div>
        </div>
      `
      );
    }, '');

    rewardTrackerRewards.style.setProperty('--rewards-count', rewards.length);
    rewardTrackerRewards.insertAdjacentHTML('beforeend', rewardsHtml);
  }

  function prepareCart() {
    for (let i = 0; i < 6; i++) {
      const emptyCartItem = getEmptyCartItemHtml();
      cartItemsElement.insertAdjacentHTML('beforeend', emptyCartItem);
    }

    document.addEventListener('click', (event) => {
      if (event.target.closest('.select-your-stash__cart__item__remove')) {
        const productId = event.target.closest('.select-your-stash__cart__item').dataset.productId;
        if (!productId) {
          console.warn('Product ID not found in cart item.');
          return;
        }
        removeCartItem(productId);
      }
    });
  }

  function getRewardsData() {
    const rewardsJson = container.dataset.rewardsJson;
    if (!rewardsJson) {
      return [];
    }

    try {
      return JSON.parse(rewardsJson);
    } catch {
      return [];
    }
  }
}
